import type { CourseRole, OrgRole, SectionRole } from "../shared/types/roles";

import type { OrgUserType, SectionUserType } from "components/server-types";

/** Mirrors server `SectionUser.enabled()` (section + org membership). */
export const isSectionUserEnabled = (
  sectionUser: SectionUserType | null,
  isOrgUserDisabled = false,
): sectionUser is SectionUserType =>
  Boolean(sectionUser && !sectionUser.is_disabled && !isOrgUserDisabled);

/** Mirrors server `User.get_role_in_section`. */
export const getEnabledSectionRole = (
  sectionUser: SectionUserType | null,
  isOrgUserDisabled = false,
): SectionRole | null => {
  if (!isSectionUserEnabled(sectionUser, isOrgUserDisabled)) {
    return null;
  }
  return sectionUser.role;
};

/** Mirrors server `User.get_role_in_course` / `CourseUser.enabled()` for a resolved assignment. */
export const getEnabledCourseRole = (
  courseUser: { role: CourseRole } | null,
  isOrgUserDisabled = false,
): CourseRole | null => {
  if (!courseUser || isOrgUserDisabled) {
    return null;
  }
  return courseUser.role;
};

/** Mirrors server `User.get_role_in_org`. */
export const getEnabledOrgRole = (orgUser: OrgUserType | null): OrgRole | null => {
  if (!orgUser || orgUser.is_disabled) {
    return null;
  }
  return orgUser.role;
};
